<template>
  <div class="container">
    <h1 class="title is-1">Our Portfolio</h1>
    <div class="page-section">
      <div class="portfolio">
        <portfolio-item src="/assets/portfolio/mcallen_firestation.jpg"></portfolio-item>


        <portfolio-item src="/assets/portfolio/stabilizing_ocelot_crossings_FM_106.jpg"></portfolio-item>
        <portfolio-item src="/assets/portfolio/apartment_rehabilitation.jpg"></portfolio-item>
        <portfolio-item src="/assets/portfolio/sci_tech_palm_transplant.jpg"></portfolio-item>
        <portfolio-item src="/assets/portfolio/hand_palm_planting_NISSAN.jpg"></portfolio-item>
        <portfolio-item src="/assets/portfolio/texas_persimmon.jpg"></portfolio-item>
        <portfolio-item src="/assets/portfolio/planting_palm.jpg"></portfolio-item>
        <portfolio-item src="/assets/portfolio/sourcing_large_palm.jpg"></portfolio-item>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portfolio',
  data() {
    return {}
  }
}
</script>

<style lang="scss">
  .portfolio {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    @supports (-ms-flow-from: thingy) { /* Edge only */
      justify-content: space-around;
    }
  }
</style>



// WEBPACK FOOTER //
// Portfolio.vue?7e07d7c2